module.exports = __webpack_public_path__ + "img/meetingName.839a671d.svg";